import React, {useEffect, useState} from 'react';
import './news.scss';

import {InfoCardType} from "../../../../models";
import {newsData} from 'data/newsData';
import {InfoCard, Button, HeadingElement} from "components";
import {useNavigate} from "react-router-dom";

export const News = () => {
    const navigate = useNavigate();
    const [news, setNews] = useState<InfoCardType[]>(newsData.filter((data) => (data.isPopular === true)));
    useEffect(() => {
        setNews(newsData.filter((data) => (data.isPopular === true)));
    }, [])

    return (
        <div className={'news'}>
            <div className="news_wrapper max">
                <div className={'news_wrapper_left'}>
                    <div className={'news_wrapper_left_content'}>
                        <div>
                            <HeadingElement/>
                            <h1>Top Articles To Read</h1>
                        </div>

                        <p>Stay informed with articles on various business topics.</p>
                        <div className={'news_wrapper_left_cta'}>
                            <Button text={'View All'} type={'primary'} onclick={() => navigate("/news")}/>
                        </div>
                    </div>
                </div>
                <div className={'news_wrapper_right'}>
                    {news.slice(0, 2).map(({id, date, heading, description, link, image}, index) => (
                        <InfoCard key={index.toString() + id} id={id + '/#view-news'} date={date} heading={heading}
                                  description={description} link={link}
                                  image={image}/>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default News;
